import React, { useState } from "react";
import { useForm } from "react-hook-form";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import DataListMain from "../DataListMain";
const LoginPage = ({ setShowAdmin }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();
  const onSubmit = (data) => {
    const { email, password } = data;
    // const [show, setShow] = useState(false);
    if (email === "admin@gmail.com" && password === "admin@123") {
      // setShow(true)
      // Navigate to /dataList page
      // navigate("/dataList");
    } else {
      // Handle invalid credentials (optional)
      alert("Invalid username or password");
    }
  };
  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const handleBack = () => {
    setShowAdmin(false)
    console.log("btn Clicked")
  }
  return (
    <Wrapper>
      {/* {show ? <DataListMain /> : ""} */}
      <div className="login-root">
        <div
          className="box-root flex-flex flex-direction--column"
          style={{ minHeight: "100vh", flexGrow: 1 }}
        >
          <div className="loginbackground box-background--white padding-top--64">
            <div className="loginbackground-gridContainer">
              <div
                className="box-root flex-flex"
                style={{ gridArea: "top / start / 8 / end" }}
              >
                <div
                  className="box-root"
                  style={{
                    backgroundImage:
                      "linear-gradient(white 0%, rgb(247, 250, 252) 33%)",
                    flexGrow: 1,
                  }}
                ></div>
              </div>
              <div
                className="box-root flex-flex"
                style={{ gridArea: "4 / 2 / auto / 5" }}
              >
                <div
                  className="box-root box-divider--light-all-2 animationLeftRight tans3s"
                  style={{ flexGrow: 1 }}
                ></div>
              </div>

              <div
                className="box-root flex-flex"
                style={{ gridArea: "7 / start / auto / 4" }}
              >
                <div
                  className="box-root box-background--blue animationLeftRight"
                  style={{ flexGrow: 1 }}
                ></div>
              </div>
              <div
                className="box-root flex-flex"
                style={{ gridArea: "8 / 4 / auto / 6" }}
              >
                <div
                  className="box-root box-background--gray100 animationLeftRight tans3s"
                  style={{ flexGrow: 1 }}
                ></div>
              </div>
              <div
                className="box-root flex-flex"
                style={{ gridArea: "2 / 15 / auto / end" }}
              >
                <div
                  className="box-root box-background--cyan200 animationRightLeft tans4s"
                  style={{ flexGrow: 1 }}
                ></div>
              </div>
              <div
                className="box-root flex-flex"
                style={{ gridArea: "3 / 14 / auto / end" }}
              >
                <div
                  className="box-root box-background--blue animationRightLeft"
                  style={{ flexGrow: 1 }}
                ></div>
              </div>
              <div
                className="box-root flex-flex"
                style={{ gridArea: "4 / 17 / auto / 20" }}
              >
                <div
                  className="box-root box-background--gray100 animationRightLeft tans4s"
                  style={{ flexGrow: 1 }}
                ></div>
              </div>
              <div
                className="box-root flex-flex"
                style={{ gridArea: "5 / 14 / auto / 17" }}
              >
                <div
                  className="box-root box-divider--light-all-2 animationRightLeft tans3s"
                  style={{ flexGrow: 1 }}
                ></div>
              </div>
            </div>
          </div>
          <div
            className="box-root padding-top--24 flex-flex flex-direction--column"
            style={{ flexGrow: 1, zIndex: 9 }}
          >
            <div className="box-root padding-top--48 padding-bottom--24 flex-flex flex-justifyContent--center">
              <h1>Admin Login</h1>
            </div>
            <div className="formbg-outer">
              <div className="formbg">
                <div className="formbg-inner padding-horizontal--48">
                  <span className="padding-bottom--15">
                    Sign in to your account
                  </span>
                  <form id="stripe-login" onSubmit={handleSubmit(onSubmit)}>
                    <div
                      className={`field padding-bottom--24 ${errors.email ? "error-border" : ""
                        }`}
                    >
                      <label htmlFor="email">Email</label>
                      <input
                        type="email"
                        placeholder="Enter your email"
                        {...register("email", {
                          required: true,
                          pattern: {
                            value: /^\S+@\S+$/i,
                            message: "Invalid email address",
                          },
                        })}
                        className={errors.email ? "error-input" : ""}
                      />
                      {errors.email && (
                        <span className="error">
                          {errors.email.message || "This field is required"}
                        </span>
                      )}
                    </div>
                    <div
                      className={`field password-field ${errors.password ? "error-border" : ""
                        }`}
                    >
                      <div className="grid--50-50">
                        <label htmlFor="password">Password</label>
                        <div className="reset-pass">
                          <a href="#/">Forgot your password?</a>
                        </div>
                      </div>
                      <div className="password-input-container eyeIconStyle">
                        <input
                          type={showPassword ? "text" : "password"}
                          placeholder="Enter your password"
                          {...register("password", { required: true })}
                          className={`password-input ${errors.password ? "error-input" : ""
                            }`}
                        />
                        <i
                          className="material-icons password-toggle-icon eyeIconS"
                          onClick={togglePasswordVisibility}
                        >
                          {showPassword ? "visibility" : "visibility_off"}
                        </i>
                      </div>
                      {errors.password && (
                        <span className="error">This field is required</span>
                      )}
                    </div>

                    <div className="field padding-bottom--24 paddT">
                      <input type="submit" name="submit" value="Continue" />
                    </div>
                    <div onClick={handleBack} className="backBtnLogin">Back To Landing Page</div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
}

export default LoginPage;
const Wrapper = styled.div`
.backBtnLogin{
  text-align: center;
  color: #5469d4;
  &:hover{
    cursor: pointer;
  }
}
  .paddT {
    padding-top: 20px;
  }
  .eyeIconStyle {
    position: relative;
  }
  .eyeIconS {
    position: absolute;
    right: 5px;
    transform: translateY(-50%);
    top: 50%;
    font-size: 22px;
    color: #5469d4;
    &:hover {
      cursor: pointer;
    }
  }
  .form__input.error-border {
    border-color: red;
  }
  .error {
    color: red;
    font-size: 0.775rem;
    margin-top: 0.25rem;
    text-align: left;
  }
  h1 {
    letter-spacing: -1px;
    color: #5469d4;
  }
  a {
    color: #5469d4;
    text-decoration: unset;
  }
  .login-root {
    background: #fff;
    display: flex;
    width: 100%;
    min-height: 100vh;
    overflow: hidden;
  }
  .loginbackground {
    min-height: 692px;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    z-index: 0;
    overflow: hidden;
  }
  .flex-flex {
    display: flex;
  }
  .align-center {
    align-items: center;
  }
  .center-center {
    align-items: center;
    justify-content: center;
  }
  .box-root {
    box-sizing: border-box;
  }
  .flex-direction--column {
    -ms-flex-direction: column;
    flex-direction: column;
  }
  .loginbackground-gridContainer {
    display: -ms-grid;
    display: grid;
    -ms-grid-columns: [start] 1fr [left-gutter] (86.6px) [left-gutter] 1fr [end];
    grid-template-columns: [start] 1fr [left-gutter] repeat(16, 86.6px) [left-gutter] 1fr [end];
    -ms-grid-rows: [top] 1fr [top-gutter] (64px) [8] [bottom-gutter] 1fr
      [bottom];
    grid-template-rows: [top] 1fr [top-gutter] repeat(8, 64px) [bottom-gutter] 1fr [bottom];
    justify-content: center;
    margin: 0 -2%;
    transform: rotate(-12deg) skew(-12deg);
  }

  .box-divider--light-all-2 {
    box-shadow: inset 0 0 0 2px #e3e8ee;
  }
  .box-background--blue {
    background-color: #5469d4;
  }
  .box-background--white {
    background-color: #ffffff;
  }
  .box-background--blue800 {
    background-color: #212d63;
  }
  .box-background--gray100 {
    background-color: #e3e8ee;
  }
  .box-background--cyan200 {
    background-color: #7fd3ed;
  }
  .padding-top--64 {
    padding-top: 64px;
  }
  .padding-top--24 {
    padding-top: 24px;
  }
  .padding-top--48 {
    padding-top: 48px;
  }
  .padding-bottom--24 {
    padding-bottom: 24px;
  }
  .padding-horizontal--48 {
    padding: 48px;
  }
  .padding-bottom--15 {
    padding-bottom: 15px;
  }

  .flex-justifyContent--center {
    -ms-flex-pack: center;
    justify-content: center;
  }

  .formbg {
    margin: 0px auto;
    width: 100%;
    max-width: 448px;
    background: white;
    border-radius: 4px;
    box-shadow: rgba(60, 66, 87, 0.12) 0px 7px 14px 0px,
      rgba(0, 0, 0, 0.12) 0px 3px 6px 0px;
  }
  span {
    display: block;
    font-size: 20px;
    line-height: 28px;
    color: #1a1f36;
  }
  label {
    margin-bottom: 10px;
  }
  .reset-pass a,
  label {
    font-size: 14px;
    font-weight: 600;
    display: block;
  }
  .reset-pass > a {
    text-align: right;
    margin-bottom: 10px;
  }
  .grid--50-50 {
    display: grid;
    grid-template-columns: 50% 50%;
    align-items: center;
  }

  .field input {
    font-size: 16px;
    line-height: 28px;
    padding: 8px 16px;
    width: 100%;
    min-height: 44px;
    border: unset;
    border-radius: 4px;
    outline-color: rgb(84 105 212 / 0.5);
    background-color: rgb(255, 255, 255);
    box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px 0px,
      rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px,
      rgba(60, 66, 87, 0.16) 0px 0px 0px 1px, rgba(0, 0, 0, 0) 0px 0px 0px 0px,
      rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px;
  }

  input[type="submit"] {
    background-color: rgb(84, 105, 212);
    box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px 0px,
      rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.12) 0px 1px 1px 0px,
      rgb(84, 105, 212) 0px 0px 0px 1px, rgba(0, 0, 0, 0) 0px 0px 0px 0px,
      rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(60, 66, 87, 0.08) 0px 2px 5px 0px;
    color: #fff;
    font-weight: 600;
    cursor: pointer;
  }
  .field-checkbox input {
    width: 20px;
    height: 15px;
    margin-right: 5px;
    box-shadow: unset;
    min-height: unset;
  }
  .field-checkbox label {
    display: flex;
    align-items: center;
    margin: 0;
  }
  a.ssolink {
    display: block;
    text-align: center;
    font-weight: 600;
  }
  .footer-link span {
    font-size: 14px;
    text-align: center;
  }
  .listing a {
    color: #697386;
    font-weight: 600;
    margin: 0 10px;
  }

  .animationRightLeft {
    animation: animationRightLeft 2s ease-in-out infinite;
  }
  .animationLeftRight {
    animation: animationLeftRight 2s ease-in-out infinite;
  }
  .tans3s {
    animation: animationLeftRight 3s ease-in-out infinite;
  }
  .tans4s {
    animation: animationLeftRight 4s ease-in-out infinite;
  }

  @keyframes animationLeftRight {
    0% {
      /* transform: translateX(0px); */
    }
    50% {
      /* transform: translateX(1000px); */
    }
    100% {
      /* transform: translateX(0px); */
    }
  }

  @keyframes animationRightLeft {
    0% {
      /* transform: translateX(0px); */
    }
    50% {
      /* transform: translateX(-1000px); */
    }
    100% {
      /* transform: translateX(0px); */
    }
  }
`;
